/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-return-await */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import moment from 'utils/moment';
import HeaderBack from '../../../../components/headerBack';
import SectionHeader from '../../../../components/sectionHeader';
import FixedFields from './components/FixedFields';
import Panel from '../../../../components/panel/Panel';
import Button from '../../../../components/button/button';
import Loading from '../../../../components/loading/loading';
import styles from './requestCreate.module.scss';
import icon from '../../../../icons/GateModule.png';
import { clearData, searchAirports, createGateRequest, getGateList } from '../../redux/actions';
import { GetFileName, S3Uploads } from '../../../services';
import { S3Select } from '../../S3Select';

class RequestLogCreate extends Component {
state = {
  info: {},
  showFormErrors: false,
  speiceError: false,
  loading: false,
  fieldErrors: {
    aircraft: false,
    deptAirport: true,
    arrival_date: true,
    in_date: true,
    from_date: true,
    remarks: false,
    to_gate: true
  },
  aircraftsList: []
}

componentDidMount = async () => {
  const { actionFetchGateList } = this.props;
  actionFetchGateList();
  await this.handleS3Data();
}

componentDidUpdate(prevProps) {
  const {
    createGateRequestAction, history, actionClear
  } = this.props;
  const { loading } = this.state;
  if (prevProps.createGateRequestAction?.loading === true && createGateRequestAction?.loading === false && loading === true) {
    this.setState({ loading: false });
    history.push('/gate_change');
    actionClear();
  }
}

getFileNames = async count => await GetFileName.getUploadFileName(count);

doS3Upload = async (files, fileIds, entity) => await S3Uploads.uploadFiles(files, fileIds.filename, entity);


handleAnswerChanged = (section, answer, fieldId) => {
  this.setState(prevState => ({
    [section]: {
      ...prevState[section],
      [fieldId]: answer
    }
  }));
}

handleFieldErrorChanged = (id, value) => {
  this.setState(prevState => ({
    fieldErrors: {
      ...prevState.fieldErrors,
      [id]: value
    }
  }));
}

create = async () => {
  const { fieldErrors, info } = this.state;
  const { actionCreate, actionUpdate, match, user } = this.props;
  const errors = { ...fieldErrors };
  const noErrors = Object.keys(errors)
    .every(k => (errors[k] === false));
  if (noErrors) {
    const data = {
      airline: user?.current_tenant?.name,
      aircraft: info?.aircraft,
      flight_number: info.flight_number,
      arrival_type: info.arrivalType,
      arrival_date: moment(info?.arrival_date).format(),
      dept_airport: info.deptAirport,
      in_date: moment(info?.in_date).format(),
      from_date: moment(info?.from_date).format(),
      remarks: info.remarks || '',
      requested_date: moment().format(),
      to_gate: info.to_gate
    };
    const formData = new FormData();
    Object.keys(data).forEach((k) => {
      if (data[k] !== 'null' && data[k] !== null) {
        formData.append(k, data[k]);
      }
    });
    this.setState({ loading: true });
    if (match?.params.id) {
      actionUpdate(match?.params.id, formData);
    } else {
      actionCreate(formData);
    }
  } else {
    this.setState({ showFormErrors: true });
  }
}

handleZoomLevel = (value) => {
  this.setState({ zoomLevel: value });
}

handleS3Data = async () => {
  await S3Select.s3SelectQuery(
    'SELECT model, manufacturer, "ICAO Code" FROM S3Object'
  ).then((data) => {
    this.setState({ aircraftsList: data });
  });
}

handleSearchForAirport = (value) => {
  const { actionAirportSearch } = this.props;
  clearTimeout(this.timeout);
  this.timeout = setTimeout(() => {
    actionAirportSearch(value);
  }, 300);
};

render() {
  const { info, showFormErrors, loading, aircraftsList } = this.state;
  const { airports_data, saveDiversionLogAction, match, gateListData } = this.props;
  const title = match.params.id
    ? 'gate_change.edit.title'
    : 'gate_change.create.formtitle';
  return (
    <>
      {saveDiversionLogAction?.success && <Redirect push to="/gate_change" />}
      <SectionHeader icon={icon} translationID="shortcuts.gate_change"
        defaultTitle="Gate Change Request"
      />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
        backRoute="/gate_change"
      />
      <Loading loadingStatus={loading} />
      <div className={`container ${styles.form}`}>
        <Panel title={title} defaultTitle="New Gate Change Request">
          <div className={`${styles.content} ${styles.embedded}`}>
            <FixedFields
              info={info}
              airports_data={airports_data}
              handleAnswerChanged={this.handleAnswerChanged}
              handleFieldErrorChanged={this.handleFieldErrorChanged}
              showFormErrors={showFormErrors}
              aircraftsList={aircraftsList?.length > 0? aircraftsList: []}
              handleSearchForAirport={this.handleSearchForAirport}
              gateListData={gateListData || []}
            />
          </div>
          <div className={`${styles.footer} ${styles.embedded}`}>
            <Button onClick={this.create} translationID="wildlife.form.submit"
              defaultText="Submit" action="secondary"
            />
          </div>
        </Panel>
      </div>
    </>
  );
}
}

RequestLogCreate.propTypes = {
  airports_data: PropTypes.arrayOf(PropTypes.shape({})),
  history: PropTypes.shape({}).isRequired
};

RequestLogCreate.defaultProps = {
  airports_data: []
};

const mapStateToProps = state => ({
  user: state.auth.profile,
  airports_data: state.gate.airports_data,
  createGateRequestAction: state.gate.createGateRequestAction,
  gateListData: state.gate.gateList
});

const mapDispatchToProps = dispatch => ({
  actionCreate: (data) => {
    dispatch(createGateRequest(data));
  },
  actionClear: () => {
    dispatch(clearData());
  },
  actionAirportSearch: (query) => {
    dispatch(searchAirports(query));
  },
  actionFetchGateList: () => {
    dispatch(getGateList());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestLogCreate);
